if(!customElements.get("product-add-on")) {
  class ProductAddOn extends HTMLElement {
    constructor() {
      super();
    }

    variantIdChangedUnsubscriber = undefined;
    
    connectedCallback() {
      // 标记
      this.marks = {
        multipleChoice: this.querySelector('.add_collection_swatch')?.classList?.contains('multiple-choice') || false
      };
      // 元素
      this.elements = {
        inputList: this.marks.multipleChoice ? this.querySelectorAll('input[type="checkbox"]') : this.querySelectorAll('input[type="radio"]'),
        buyButton: document.querySelector('.buy-buttons-group add-cart-button')
      };

      // 订阅事件：变体切换
      this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        let variant = event.data.variant;

        // console.log('触发Subscribe Event - ProductAddOn variant: ', variant);

        // 根据当前选中的产品变体库存状态，更新add cart button状态
        this.elements.buyButton.setAttribute('data-variant-id', variant.id);
        if(variant.available) {
          this.elements.buyButton.removeAttribute('disabled');
        } else {
          this.elements.buyButton.setAttribute('disabled', 'disabled');
        }

        // 更新ids
        this.setIds(this.elements.inputList);
      });

      document.addEventListener('DOMContentLoaded', () => {
        // console.log('this.marks.multipleChoice: ', this.marks.multipleChoice);
        this.handleAddonInputChange(this.elements.inputList);
      });
    }

    disconnectedCallback() {
      if (this.variantIdChangedUnsubscriber) {
        this.variantIdChangedUnsubscriber();
      }
    }

    // Add on product-element input checked状态改变时触发，获取当前选中的choice option
    handleAddonInputChange(element) {
      element.forEach(el => {
        el.addEventListener('change', () => {
          this.setIds(element);
        });
      });
    }

    // Get checked value of add on product-element
    getCheckedIds(element) {
      return [...element].filter(input => input.checked && parseInt(input.value) != 0).map(input => parseInt(input.value));
    }

    // Set new ids to product-add-on
    setIds(element) {
      let curr_variant_id = parseInt(this.elements.buyButton.getAttribute('data-variant-id'));
      let idsArr = this.getCheckedIds(element);
      // console.log('idsArr: ', idsArr);
      if(idsArr.length > 0) {
        idsArr.unshift(curr_variant_id);
        this.elements.buyButton.setAttribute('data-variant-id', idsArr.join(','));
      } else {
        this.elements.buyButton.setAttribute('data-variant-id', curr_variant_id);
      }
    }
  }

  customElements.define("product-add-on", ProductAddOn);
}
